import { useContext } from "react";
import LyricsModalContext from "../contexts/lyrics-modal-context/LyricsModalContext";

export const useLyricsModal = () => {
  const context = useContext(LyricsModalContext);
  if (context === undefined) {
    throw new Error('useLyricsModal must be used within a LyricsModalProvider');
  }
  
  return context;
};